const pages = {
  app: {
    home: '/acasa',
    grid: '/rezolva-grile',
    subject: '/simulari',
    dashboard: '/statistici',
    ranking: '/clasament',
    history: '/istoric-grile',
    payment: '/abonamente',
    profile: '/profil',
    contact: '/contact',
    createGrid: '/creaza-grila',
    createSubject: '/creaza-subiect',
    createMail: '/creaza-mail',
    createVoucher: '/creaza-voucher',
    reports: '/rapoarte',
    teacher: '/profesor',
  },
  auth: {
    login: '/login',
    register: '/signup',
    forgotPassword: '/recuperare-parola',
    resetPassword: '/resetare-parola',
    unsubscribe: '/dezabonare',
    confirmAccount: '/confirmare-cont',
  },
  other: {
    privacyPolicy: '/politica-de-confidentialitate',
    termsAndConditions: '/termeni-si-conditii',
  },
}

export default pages
